import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { ProgressIndicator } from './ProgressIndicator';
import {
  GetIndividualCounts,
  GetFamilyCounts,
  CoverageDetailedSummary,
} from 'src/Member/utils/Coverage';
import Skeleton from './skeleton/GenericSkeleton';
import { useSelector } from 'react-redux';
import { axiosInstance } from 'src/api/axios';
import { NetworkFilter } from '../coverage-filter/NetworkFilter';

export const NetworkCardWithTier = ({
  label,
  planDetails,
  PenaltyPlanDetails,
  OutOfNetworkPlanDetails,
  dataFetching,
  CurrentActive,
  isFamilySelected,
  networkLabel,
  networkPlandetails,
  accumsFinalUrl,
  networkProps,
  activeCoverageType,
  setSelectedTier,
  showDedLabel = false,
  showOopLabel = false,
  displayTierFromOutOfNetwork,
}) => {
  const { Value_Network_For_Coverage_Admin } =
    useSelector((state) => state.app.appConfigs.Network_Setting) || 'network';
  const [dataFetchingCard, setDataFetchingCard] = useState(true);
  const [activeTier, setActiveTier] = useState();
  const [tierOptions, setTierOptions] = useState();
  const [countsInformation, setCountsInformation] = useState();
  const { Display_Penalty_OR_OutOfNetwork } =
    useSelector((state) => state.app.appConfigs.Network_Setting) ||
    'Out-Of-Network';
  const accumsLabel = `Use dropdown to view Additional Coverage ${
    Value_Network_For_Coverage_Admin === 'network' ? 'Networks' : 'Tiers'
  } .`;

  const tierChangeHandler = (selectedTier) => {
    setActiveTier(selectedTier);
    setSelectedTier(selectedTier);
    setSelectedTier({ ...selectedTier, initialLoad: false });
    if (selectedTier.value !== -1 && selectedTier.value !== -2) {
      setDataFetchingCard(true);
      fetchTierData(selectedTier.value);
    } else {
      if (selectedTier.label === 'Out Of Network') {
        const countInformation = isFamilySelected
          ? GetFamilyCounts('Out-of-network Summary', OutOfNetworkPlanDetails)
          : GetIndividualCounts(
              'Out-of-network Summary',
              OutOfNetworkPlanDetails,
            );
        setCountsInformation(countInformation);
      } else if (selectedTier.label === 'Tier: Out of Network') {
        const countInformation = isFamilySelected
          ? GetFamilyCounts('Penalty Summary', PenaltyPlanDetails)
          : GetIndividualCounts('Penalty Summary', PenaltyPlanDetails);
        setCountsInformation(countInformation);
      }
    }
  };

  const frmeUrlBasedonNetwork = (networkdID) => {
    const urlString = accumsFinalUrl.split('networkid/');
    const urlPart = urlString[1].split('/product');
    const finalUrl = `${urlString[0]}networkid/${networkdID}/product${urlPart[1]}`;
    return finalUrl;
  };

  const fetchTierData = async (networkdID) => {
    const apiUrl = frmeUrlBasedonNetwork(networkdID);
    console.log(apiUrl);
    const responseAccumulator = await axiosInstance.get(apiUrl);
    const memberAccumSummaryData = responseAccumulator.data.Response;

    const detailedSummaryData = CoverageDetailedSummary(
      planDetails.MemberCoverage,
      memberAccumSummaryData,
    );
    const activeCoverageAmounts = detailedSummaryData.filter(
      (eachRecord) => eachRecord.Product === activeCoverageType,
    );
    const countInformation = isFamilySelected
      ? GetFamilyCounts(
          'In-network Summary',
          activeCoverageAmounts[0].InNetworkPlanDetails,
        )
      : GetIndividualCounts(
          'In-network Summary',
          activeCoverageAmounts[0].InNetworkPlanDetails,
        );
    setCountsInformation(countInformation);
    setDataFetchingCard(false);
    console.log(memberAccumSummaryData);
  };

  useEffect(() => {
    if (
      networkProps.length > 0 &&
      accumsFinalUrl !== '' &&
      activeCoverageType !== ''
    ) {
      const networkOptionDetails = [...networkProps];
      if (!displayTierFromOutOfNetwork) {
        networkOptionDetails.shift();
      }
      const inesertOutOfNetwork =
        Display_Penalty_OR_OutOfNetwork === 'Out-Of-Network' ? true : false;
      const inesertPenaltyNetwork =
        Display_Penalty_OR_OutOfNetwork === 'Penalty' ? true : false;
      if (inesertOutOfNetwork) {
        networkOptionDetails.push({ label: 'Out Of Network', value: -1 });
      }
      if (inesertPenaltyNetwork) {
        networkOptionDetails.push({ label: 'Tier: Out of Network', value: -2 });
      }
      setTierOptions(networkOptionDetails);
      setActiveTier(networkOptionDetails[0]);
      setSelectedTier({ ...networkOptionDetails[0], initialLoad: true });
      if (
        networkOptionDetails[0].value !== -1 &&
        networkOptionDetails[0].value !== -2
      ) {
        fetchTierData(networkOptionDetails[0].value);
      } else {
        if (networkOptionDetails[0].label === 'Out Of Network') {
          const countInformation = isFamilySelected
            ? GetFamilyCounts('Out-of-network Summary', OutOfNetworkPlanDetails)
            : GetIndividualCounts(
                'Out-of-network Summary',
                OutOfNetworkPlanDetails,
              );
          setCountsInformation(countInformation);
        } else if (networkOptionDetails[0].label === 'Tier: Out of Network') {
          const countInformation = isFamilySelected
            ? GetFamilyCounts('Penalty Summary', PenaltyPlanDetails)
            : GetIndividualCounts('Penalty Summary', PenaltyPlanDetails);
          setCountsInformation(countInformation);
        }
        setDataFetchingCard(false);
      }
    }
  }, [
    networkProps,
    accumsFinalUrl,
    activeCoverageType,
    isFamilySelected,
    displayTierFromOutOfNetwork,
  ]);

  useEffect(() => {
    if (activeTier?.label === 'Out Of Network') {
      const countInformation = isFamilySelected
        ? GetFamilyCounts('Out-of-network Summary', OutOfNetworkPlanDetails)
        : GetIndividualCounts(
            'Out-of-network Summary',
            OutOfNetworkPlanDetails,
          );
      setCountsInformation(countInformation);
    } else if (activeTier?.label === 'Tier: Out of Network') {
      const countInformation = isFamilySelected
        ? GetFamilyCounts('Penalty Summary', PenaltyPlanDetails)
        : GetIndividualCounts('Penalty Summary', PenaltyPlanDetails);
      setCountsInformation(countInformation);
    }
  }, [OutOfNetworkPlanDetails, PenaltyPlanDetails]);

  return (
    <>
      {dataFetching || dataFetchingCard ? (
        <Skeleton />
      ) : (
        <Card>
          <div className="mb-4">
            <p className="text-left">{accumsLabel}</p>
            <span>
              {Value_Network_For_Coverage_Admin === 'tier'
                ? 'Network Tier'
                : 'Network'}
            </span>
            <NetworkFilter
              networkProps={{
                options: tierOptions,
                selectedNetwork: activeTier,
              }}
              networkChangeHandler={tierChangeHandler}
            />
          </div>
          <div className="mb-3">
            <ProgressIndicator
              label="Deductible"
              max={countsInformation?.deductable?.deductableMax}
              applied={countsInformation?.deductable?.appliedAmount}
              showCustomLabel={isFamilySelected ? false : showDedLabel}
              msg="See Family Deductible"
            />
          </div>
          <div className="mt-3">
            <ProgressIndicator
              label="Out-of-pocket"
              max={countsInformation?.outOfPocket?.outOfPocketMax}
              applied={countsInformation?.outOfPocket?.appliedAmount}
              showCustomLabel={isFamilySelected ? false : showOopLabel}
              msg="See Family Out of Pocket"
            />
          </div>
        </Card>
      )}
    </>
  );
};
